<template>
  <el-dropdown style="padding:0px" @command="handleCommand">
    <span class="el-dropdown-link">
      <!-- 下拉菜单 -->
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="">全部</el-dropdown-item>
      <el-dropdown-item command="题库">题库</el-dropdown-item>
      <el-dropdown-item command="直播">直播</el-dropdown-item>
      <el-dropdown-item command="录播">录播</el-dropdown-item>
      <el-dropdown-item command="面授">面授</el-dropdown-item>
      <el-dropdown-item command="套餐">套餐</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
 
<script>
export default {
  data() {
    return {
      value: ""
    };
  },
  props: {
    options: {
      type: Array,
      default: function() {
        return [
          { label: "全部", value: "全部" },
          { label: "题库", value: "题库" },
          { label: "套餐", value: "套餐" }
        ];
      }
    }
  },
  watch: {
    defaultValue(newVal, oldVal) {
      let self = this;
      self.value = newVal;
    }
  },
  methods: {
    handleCommand(command) {
      this.$emit("selectChange", command);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/agencyGoods/SelectHeader.vue